template(lang="pug")
  .meeting-rec

    // Header Toolbar
    .toolbar
    		
      button.icon-btn(@click="m_fileUpload" title="Add New")
        b-icon(icon="upload")

      button.icon-btn(@click="m_save" title="Save")
         fa-icon(icon="save")

      button.icon-btn(@click="$emit('cancel')" title="Close")
        fa-icon(icon="undo")

      button.icon-btn(@click="$emit('delete')" title="delete")
        fa-icon(icon="plus")
          

    // Subject
    .form-row
      label Subject
      input.form-control(type="text" v-model="d_meeting.meetingSubject")

    .form-row.d_flex
        .flex-col
           label When
           .d_flex
              input.form-control(type="date" v-model="d_meeting.meetingDate")
              input.form-control.ml-2(type="time" v-model="d_meeting.meetingTime")
			  
	.form-row
     label Duration
      b-form-select.styled-select.styled-input(
        id="duration"
        size="sm"
        v-model="d_meeting.meetingDuration"
        :options="d_durationOptions"
      )	

    // Status
    .form-row
      label Status
      b-form-select.styled-select.styled-input(
        id="status"
        size="sm"
        v-model="d_meeting.status"
        :options="d_meetingStatuses"
      )

    // Summary
    .form-row
      label Summary
      textarea.form-control(rows="3" v-model="d_meeting.meetingSummary")

    // Attendees (Two Columns)
    .form-row
      label Attendees

      .attendee-columns

        // External Attendees
        .attendee-col
          .form-group
            label.required-label External Attendees
            kt-list(
              p_appEntKey="extr"
              id="externalAttendees"
              :p_currentVals="d_meeting.externalAttendees"
              :p_readOnly="p_mode=='view'"
              :p_enableCreate="false"
              :p_enableAdd="false"
              @change="d_meeting.externalAttendees = $event"
            )

        // Internal Attendees
        .attendee-col
          .form-group
            label Team Member(s)
            kt-list(
              id="internalAttendees"
              p_appEntKey="team"
              :p_currentVals="d_meeting.internalAttendees"
              :p_readOnly="p_mode=='view'"
              :p_enableCreate="false"
              :p_enableAdd="true"
              @change="d_meeting.internalAttendees = $event"
            )

    // Tags
    .form-row
      label Tags
      .tags
        span.tag-chip(v-for="(tag, idx) in d_meeting.tags" :key="idx")
          | {{ tag }}
          button(@click="removeTag(idx)") x

        input.form-control(
          v-model="tagInput"
          @keyup.enter="addTag"
          placeholder="Add tag and press Enter"
        )

    // Delete Button
    .form-actions
      button.btn.btn-danger(
        v-if="isEdit"
        @click="$emit('delete', d_meeting.meetingId)"
      ) Delete

<script>
import {fn_callAIProcessFile,fn_saveMeeting, fn_updateMeetingColumn,fn_deleteRecord} from "@/utils/api.js";
export default {
  name: "MeetingRec",

  props: {
    p_meeting: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      d_meeting: this.p_meeting,
	  d_meetingMinutes:null,
	  d_meetingStatuses:['Scheduled','In Progress','Completed','Cancelled','No Show'],
	  d_durationOptions:['30','60','90'],
	  };
  },
  computed: {
    isEdit() {
      return !!this.form.meetingId;
    }
  },

  methods: {
    m_addTag() {
      if (!this.tagInput.trim()) return;
      this.form.tags.push(this.tagInput.trim());
      this.tagInput = "";
    },

    m_removeTag(idx) {
      this.form.tags.splice(idx, 1);
    },

    m_addExternal() {
      if (!this.externalInput.trim()) return;
      this.form.externalAttendees.push(this.externalInput.trim());
      this.externalInput = "";
    },

    m_removeExternal(idx) {
      this.form.externalAttendees.splice(idx, 1);
    },

    m_addInternal() {
      if (!this.internalInput.trim()) return;
      this.form.internalAttendees.push(this.internalInput.trim());
      this.internalInput = "";
    },

    m_removeInternal(idx) {
      this.form.internalAttendees.splice(idx, 1);
    },
    m_removeAttendee(idx) {
      this.form.attendees.splice(idx, 1);
    },

    m_save() {
      this.$emit("save", { ...this.d_meeting });
    },
	m_fileUpload(){

		const input = document.createElement("input");
		input.type = "file";
		input.accept = ".pdf,.doc,.docx,.txt,.vtt,.mp4,.webm,.m4a,.wav,.mp3";

		input.onchange = (e) => {
			const file = e.target.files[0];
			this.d_meetingMinutes = file;
			this.m_processFile();
		};

		input.click();
    },
    m_processFile(){


       let promptText = 
            `You are an expert meeting analyst. Summarize the following meeting in a clear, structured format.

             Your summary must include:
             1. **Overview** – A concise description of the meeting purpose and context.
             2. **Key Discussion Points** – Bullet points capturing the main topics discussed.
             3. **Decisions Made** – Every confirmed decision, agreement, or conclusion.
             4. **Action Items** – Each task with:
             - Owner (person responsible)
             - Description
             - Deadline (if mentioned or implied)
             5. **Risks / Concerns** – Any issues raised, blockers, or dependencies.
             6. **Next Steps** – What happens after this meeting.
             7. **Tags** – Generate 3–7 relevant tags based on the content (e.g., “Client”, “Budget”, “Technical”, “Follow-up”).

            Rules:
            - Use clear, professional language.
            - Do NOT invent information; only use what is present.
            - If something is implied, state it as “likely” or “pending confirmation”.
            - Keep the summary compact but complete.

        Input:
        ${this.d_meetingMinutes} 

    Output:
      Provide the summary in clean sections exactly as specified above`.

 
      this.d_loading=true;



   const payload = {prompt:promptText};

 // Build FormData
    const formData = new FormData();

    // Append JSON payload as a string
    formData.append("payload", JSON.stringify(payload));

    // Append the file
    formData.append("resume", this.d_resumeFile);
	

fn_callAIProcessFile(formData)
  .then(resp => {
	 
    this.d_loading = false;
  })

  .catch(err => {
    console.error(err);
    this.d_loading = false;

    const status = err?.response?.status;

    if (status === 500 || status === 503) {
      kbdpAlert.showErr("AI outage, kindly retry");
      return;
    }

    kbdpAlert.showErr("Error: Unable to upload resume, file might be too large!!");
  });

  
  },	
  }
};
</script>

<style scoped>
.meeting-rec {
  padding: 1em;
  display: flex;
  flex-direction: column;
  gap: 1em;
}

/* Toolbar */
.toolbar {
  display: flex;
  justify-content: flex-end;
  gap: 0.6em;
  margin-bottom: 1em;
}

.icon-btn {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0.3em;
}

.icon-btn svg {
  width: 22px;
  height: 22px;
  fill: #333;
}

.form-row {
  display: flex;
  flex-direction: column;
}

.tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5em;
}

.tag-chip {
  background: #e0e0e0;
  padding: 0.3em 0.6em;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 0.3em;
}
.form-actions {
  margin-top: 1em;
}
.attendee-columns {
  display: flex;
  gap: 2em;
}
.attendee-col {
  flex: 1;
}


</style>
